import { Space, Tag, Typography } from "antd"
import moment from "moment"
import { centsToDollarsDisplay } from "../../displayFormatters"
import {
  Proposal,
  ProposalStatuses,
  calculateTotalPrice,
  countFollowUpsSent,
  countProposalGroups,
  hasActiveAutomations,
  proposalDisplayName,
  proposalStatusColors,
  proposalStatusLabels
} from "./proposalsModel"

type Props = {
  proposal: Proposal
}

const formatTimestamp = (value: string | undefined) => {
  if (value === undefined || value === null || value === '') {
    return undefined
  }
  return moment.utc(value).local().format("MMM D, YYYY")
}

const ProposalVersionRow = ({ proposal }: Props) => {
  const groupCount = countProposalGroups(proposal)
  const workareaCount = proposal.workareas.length
  const followUpsSent = countFollowUpsSent(proposal)

  const metaParts = [
    `${groupCount} ${groupCount === 1 ? 'Group' : 'Groups'}, ${workareaCount} ${workareaCount === 1 ? 'Work Area' : 'Work Areas'}`,
    `Created: ${formatTimestamp(proposal.initiateDateUtc) ?? '—'}`
  ]
  if (proposal.status === ProposalStatuses.Approved && proposal.approveDateUtc) {
    metaParts.push(`Approved: ${formatTimestamp(proposal.approveDateUtc)}`)
  }
  if (proposal.status === ProposalStatuses.Draft && proposal.lastEditedAtUtc) {
    metaParts.push(`Last Edited: ${moment.utc(proposal.lastEditedAtUtc).local().fromNow()}`)
  }

  return <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '12px', width: '100%' }}>
    <div style={{ flexGrow: 1, minWidth: 0 }}>
      <Space size="small" wrap>
        <Typography.Text strong>{proposalDisplayName(proposal)}</Typography.Text>
        <Typography.Text type="secondary">v{proposal.versionNumber}</Typography.Text>
        {hasActiveAutomations(proposal) && <Tag color="green">Follow Ups Active</Tag>}
      </Space>
      <div>
        <Typography.Text type="secondary" style={{ fontSize: '12px' }}>
          {metaParts.join('  |  ')}
        </Typography.Text>
      </div>
    </div>
    {followUpsSent > 0 && <div style={{ textAlign: 'center' }}>
      <Typography.Text strong style={{ display: 'block' }}>{followUpsSent}</Typography.Text>
      <Typography.Text type="secondary" style={{ fontSize: '12px' }}>Follow Ups Sent</Typography.Text>
    </div>}
    <Tag color={proposalStatusColors[proposal.status]}>{proposalStatusLabels[proposal.status]}</Tag>
    <Typography.Text strong style={{ minWidth: '90px', textAlign: 'right' }}>
      {centsToDollarsDisplay(calculateTotalPrice(proposal.workareas))}
    </Typography.Text>
  </div>
}

export default ProposalVersionRow
